import Flex from 'components/ui/Flex';
import Text from 'components/ui/Text';
import useAppSelector from 'hooks/useAppSelector';
import { skuLocationSelectors } from 'store/reducers/skuLocationSlice';

type SkuLocationCellProps = {
    sku?: string | null;
};

const SkuLocationCell = ({ sku }: SkuLocationCellProps) => {    
    const skuLocations = useAppSelector(skuLocationSelectors.selectSkuLocations);
    const skuLocation = sku ? skuLocations[sku] : undefined;

    return (
        <Flex align="center">
            <Text as="label" xBold fontSize={11}>
                {skuLocation ?? '-'}
            </Text>
        </Flex>
    );
};

export default SkuLocationCell;
